import { useEffect } from "react";
import { useAppContext } from "../app/AppContext";
import styles from "./LegalPage.module.css";
import { LEGAL_COPY, type LegalDocument } from "./legal-copy";

/** Privacy and Terms, the same page in the public shell and the member shell. */
export function LegalPage({ document }: { document: LegalDocument }) {
  const { locale, experience } = useAppContext();
  const text = LEGAL_COPY[locale][document];
  useEffect(() => {
    const previous = window.document.title;
    window.document.title = `${text.title} · ${experience.brand.name}`;
    return () => {
      window.document.title = previous;
    };
  }, [text.title, experience.brand.name]);
  return (
    <article className={styles.page} data-legal-document={document}>
      <header className={styles.header}>
        <h1 className={styles.title}>{text.title}</h1>
        <p className={styles.updated}>{text.updated}</p>
        <p className={styles.intro}>{text.intro}</p>
      </header>
      {text.sections.map((section) => (
        <section key={section.title} className={styles.section}>
          <h2 className={styles.sectionTitle}>{section.title}</h2>
          {section.paragraphs.map((paragraph) => (
            <p key={paragraph} className={styles.paragraph}>
              {paragraph}
            </p>
          ))}
        </section>
      ))}
    </article>
  );
}
